/**
 * Волна D (docs/MIGRATION_ROUTER.md §5).
 * Было: <PrivateRoute path='/cabinet' redirectPathname='/'> (не-exact —
 * матчил вкладки /cabinet/orders и т.п.).
 * Фаза 5: PrivateRoute удалён — auth-гард через authGuardShell.
 */
import { createFileRoute } from '@tanstack/react-router';
import { authGuardShell } from '../compat/shells';
import PersonalArea from '@routes/PersonalArea';

export const Route = createFileRoute('/cabinet/$')({
  component: authGuardShell(PersonalArea, '/cabinet')
});
